"use client";
import * as e from "react";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { DndContext as r, KeyboardSensor as i, MouseSensor as a, TouchSensor as o, closestCenter as s, useSensor as c, useSensors as l } from "@dnd-kit/core";
import { SortableContext as u, arrayMove as d, useSortable as f, verticalListSortingStrategy as p } from "@dnd-kit/sortable";
import { CSS as m } from "@dnd-kit/utilities";
// src/components/data-table/DataTableDraggable.tsx
function h({ enabled: t, getRows: n, extractRowId: r, onRowReorder: s }) {
	let u = c(a, {}), f = c(o, {}), p = c(i, {});
	return {
		sensors: l(u, f, p),
		handleDragEnd: e.useCallback((e) => {
			if (!t) return;
			let { active: i, over: a } = e;
			if (!i || !a || i.id === a.id) return;
			let o = n(), c = o.map((e, t) => r(e, t)), l = c.indexOf(i.id), u = c.indexOf(a.id);
			if (l < 0 || u < 0 || l === u) return;
			let f = o.map((e) => e.original), p = d(f, l, u), m = d(c, l, u);
			s?.({
				newData: p,
				orderIds: m
			});
		}, [
			t,
			n,
			r,
			s
		])
	};
}
var g = e.forwardRef(({ ...e }, r) => /* @__PURE__ */ t("div", {
	ref: r,
	className: "flex items-center justify-center text-muted-foreground cursor-grab active:cursor-grabbing",
	...e,
	children: /* @__PURE__ */ n("svg", {
		width: "14",
		height: "14",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [/* @__PURE__ */ t("line", {
			x1: "9",
			y1: "4",
			x2: "9",
			y2: "20"
		}), /* @__PURE__ */ t("line", {
			x1: "15",
			y1: "4",
			x2: "15",
			y2: "20"
		})]
	})
}));
g.displayName = "DragHandle";
function _(e) {
	let t = f({ id: e }), n = {
		transform: m.Transform.toString(t.transform),
		transition: t.transition,
		position: "relative",
		zIndex: t.isDragging ? 5 : void 0
	};
	return {
		...t,
		style: n
	};
}
export { r as DndContext, g as DragHandle, u as SortableContext, d as arrayMove, s as closestCenter, h as useDndReorder, _ as useSortableRow, p as verticalListSortingStrategy };

//# sourceMappingURL=DataTableDraggable.js.map